<label class="input-wrapper">

  <span class="label-text">
    {{ label }}
    @if (required) {
    <em>*</em>
    }
  </span>


  <mat-form-field appearance="outline" class="full-width" [attr.data-options-count]="options.length">
    <mat-select [formControl]="control" [required]="required" placeholder="None" panelClass="select-panel-open">

      @for (option of options; track option.value) {
      <mat-option [value]="option.value">
        {{ option.label }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (control.hasError('required') && control.touched) {
  <p class="error-message">
    {{ label }} is required.
  </p>
  }